import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'angular-lib';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'ez-legals',
    template: require('./legals.component.html'),
    styles: [require('./legals.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class LegalsComponent implements OnInit {
    public legalType: string = '';
    public legalApi = null;
    public legalResult: string = '';

    constructor(
        private apiService: ApiService,
        private route: ActivatedRoute,
        private loaderService: LoaderService
    ) {}

    public ngOnInit() {
        this.route.params.subscribe(params => {
            if (params.type) {
                this.legalType = params.type;
                switch (this.legalType) {
                    case 'cgu':
                        this.legalApi = this.apiService.cgu();
                        break;

                    case 'legal':
                        this.legalApi = this.apiService.legal();
                        break;

                    default:
                        break;
                }
                this.loaderService.show();

                if (this.legalApi !== null) {
                    this.legalApi.subscribe(
                        (data) => {
                            this.legalResult = data;
                            this.loaderService.hide();
                        },
                        error => {
                            this.loaderService.hide();
                        }
                    );
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/legals/legals.component.ts